var _rect, _rect2, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAr(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 900 600",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 450,
    height: 600,
    fill: "#006233"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 450,
    width: 450,
    height: 600,
    fill: "#FFFFFF"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(450, 300)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M -40,0 A 40,40 0 0,1 40,0 A 25,25 0 0,0 -25,0 Z",
    fill: "#D21034"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(15, 0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 0,-10 L 3,-3 L 10,-3 L 5,2 L 8,10 L 0,5 L -8,10 L -5,2 L -10,-3 L -3,-3 Z",
    fill: "#D21034"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAr);
export default __webpack_public_path__ + "static/media/ar.7a4254d1bb96acb1840361e2c9a08e19.svg";
export { ForwardRef as ReactComponent };